<template>
    <div>
        <el-form-item
            :label="currentField.label">
        </el-form-item>
        <div class="row">
            <div class="col-12 pdf-item" :componentvalue="currentField.streetAddress1Value">
                <el-form-item
                    :label="currentField.streetAddress1Label">
                    <el-input v-model="currentField.streetAddress1Value" v-bind="attributesBinding" v-on:change="streetAddress1Change">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-12 pdf-item" :componentvalue="currentField.streetAddress2Value">
                <el-form-item
                    :label="currentField.streetAddress2Label">
                    <el-input v-model="currentField.streetAddress2Value" v-bind="attributesBinding" v-on:change="streetAddress2Change">
                    </el-input>
                </el-form-item>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pdf-item" :componentvalue="currentField.cityValue">
                <el-form-item
                    :label="currentField.cityLabel">
                    <el-input v-model="currentField.cityValue" v-bind="attributesBinding" v-on:change="cityChange">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-6 pdf-item" :componentvalue="currentField.stateValue">
                <el-form-item
                    :label="currentField.stateLabel">
                    <el-input v-model="currentField.stateValue" v-bind="attributesBinding" v-on:change="stateChange">
                    </el-input>
                </el-form-item>
            </div>
        </div>
        <div class="row">
            <div class="col-12 pdf-item" :componentvalue="currentField.postalValue">
                <el-form-item
                    :label="currentField.postalLabel">
                    <el-input v-model="currentField.postalValue" v-bind="attributesBinding" v-on:change="postalChange">
                    </el-input>
                </el-form-item>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: 'Address',
  props: ['currentField'],
  data() {
    return {
    };
  },
  methods: {
    streetAddress1Change(value) {
      this.currentField.streetAddress1Value = value.length == 0 ? '' : value;
      this.addressValue();
    },
    streetAddress2Change(value) {
      this.currentField.streetAddress2Value = value.length == 0 ? '' : value;
      this.addressValue();
    },
    cityChange(value) {
      this.currentField.cityValue = value.length == 0 ? '' : value;
      this.addressValue();
    },
    stateChange(value) {
      this.currentField.stateValue = value.length == 0 ? '' : value;
      this.addressValue();
    },
    postalChange(value) {
      this.currentField.postalValue = value.length == 0 ? '' : value;
      this.addressValue();
    },

    addressValue() {
        let seprate =   this.currentField.streetAddress1Value.length != 0 || this.currentField.streetAddress2Value.length != 0 || 
        this.currentField.cityValue.length != 0 || this.currentField.stateValue.length != 0 || this.currentField.postalValue.length != 0  ? '|' : '';

        this.currentField.componentValue = this.currentField.streetAddress1Value + seprate + this.currentField.streetAddress2Value + seprate + this.currentField.cityValue + seprate + this.currentField.stateValue + seprate + this.currentField.postalValue;
    },

    setAddressValue() {
        // let data = this.currentField.componentValue.indexOf('|');
        let data = [];

       for (var i = 0; i < this.currentField.componentValue.length; i++) {
          let val = this.currentField.componentValue.charAt(i);
          if(val == '|'){
             data.push(i);
          }
             
       }
        console.log('data', data);

        this.currentField.streetAddress1Value = this.currentField.componentValue.substr(0,data[0]);
        this.currentField.streetAddress2Value = this.currentField.componentValue.substr(data[0]+1 ,data[1]-data[0]-1);
        this.currentField.cityValue = this.currentField.componentValue.substr(data[1]+1 ,data[2]-data[1]-1);
        this.currentField.stateValue = this.currentField.componentValue.substr(data[2]+1 ,data[3]-data[2]-1);
        this.currentField.postalValue = this.currentField.componentValue.substr(data[3]+1 ,this.currentField.componentValue.length);
    },
  },
  mounted() {
    if (this.currentField.componentValue.length > 0) {
        this.setAddressValue();
    }
  },
  computed: {
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    }
  },
};
</script>